(function VariantDownloads(){

	function findContainers(){
		return document.querySelectorAll('[data-variant-downloads]');
	}

	function parseMap(raw){
		if(!raw){ return {}; }
		try {
			return JSON.parse(raw);
		} catch(err){
			console.warn('variant-downloads:', 'JSON parse failed', err);
			return {};
		}
	}

	function buildBadge(item){
		const a = document.createElement('a');
		a.className = 'variant-downloads__badge';
		a.href = item.url;
		a.target = item.target || '_blank';
		a.rel = 'noopener noreferrer';
		a.setAttribute('data-download','');
		a.innerHTML = `\n      <svg viewBox="0 0 24 24" aria-hidden="true">\n        <path d="M12 3v12m0 0 5-5m-5 5-5-5M5 19h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>\n      </svg>\n      ${item.title || item.url}\n    `;
		return a;
	}

	function createRenderer(container, map){
		return function render(variantId){
			const downloads = map[variantId];
			container.innerHTML = '';
			if(!downloads || !downloads.length){
				container.classList.add('hidden');
				return;
			}
			container.classList.remove('hidden');
			downloads.forEach(item => {
				if(!item || !item.url){
					return;
				}
				container.appendChild(buildBadge(item));
			});
		};
	}

	function hookVariantChanges(renderers){
		// Listen for theme custom event
		document.addEventListener('variant:change', e => {
			const v = e.detail && e.detail.variant ? e.detail.variant : null;
			if(v && v.id){
				renderers.forEach(render => render(String(v.id)));
			}
		});

		// Observe variant ID form inputs
		const variantInput = document.querySelector('input[name="id"], select[name="id"]');
		if(!variantInput){ return; }
		let currentId = variantInput.value;
		if(currentId){ 
			renderers.forEach(render => render(currentId));
		}

		const observer = new MutationObserver(() => {
			const newId = variantInput.value;
			if(newId !== currentId){
				currentId = newId;
				renderers.forEach(render => render(newId));
			}
		});
		observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

		variantInput.addEventListener('change', () => {
			const newId = variantInput.value;
			renderers.forEach(render => render(newId));
		});
	}

	function init(){
		let containers = findContainers();
		if(containers.length === 0){
			// Poll a few times in case section lazy-loads
			let attempts = 0;
			const timer = setInterval(() => {
				attempts++;
				containers = findContainers();
				if(containers.length > 0 || attempts > 10){
					clearInterval(timer);
					if(containers.length > 0){ initWithContainers(containers); }
				}
			}, 200);
			return;
		}
		initWithContainers(containers);
	}

	function initWithContainers(containers){
		const renderers = [];
		containers.forEach(container => {
			const raw = container.getAttribute('data-variant-downloads');
			const map = parseMap(raw);
			const render = createRenderer(container, map);
			renderers.push(render);
			
			// Initial render fallback
			if(!container.classList.contains('hidden') && container.children.length === 0){
				const first = Object.keys(map)[0];
				if(first){ render(first); }
			}
		});
		
		if(renderers.length > 0){
			hookVariantChanges(renderers);
		}
	}

	document.addEventListener('DOMContentLoaded', init);
})();
